(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.getElementById('openFilters');
    const closeBtn = document.getElementById('closeFilters');
    const overlay = document.getElementById('filterOverlay');
    const drawer = document.getElementById('filterDrawer');
    const applyBtn = document.getElementById('applyFilters');
    const clearBtn = document.getElementById('clearFilters');
    const filterToggles = document.querySelectorAll('.filter-toggle');

    // Ouvrir le drawer
    openBtn.addEventListener('click', function () {
      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    // Fermer le drawer
    function closeDrawer() {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    // Toggle filter sections
    filterToggles.forEach((toggle) => {
      toggle.addEventListener('click', function () {
        const filterName = this.getAttribute('data-filter');
        const content = document.querySelector(`[data-filter-content="${filterName}"]`);
        const icon = this.querySelector('.toggle-icon');

        if(this.classList.contains('active')){
          icon.innerText = "+";
        }else{
            icon.innerText = "-";
        }

        this.classList.toggle('active');
        content.classList.toggle('active');
      });
    });

    // Apply filters
    applyBtn.addEventListener('click', function () {
      const url = new URL(window.location.href);
      const searchParams = url.searchParams;

      // Clear existing filters
      Array.from(searchParams.keys()).forEach((key) => {
        if (key.startsWith('filter.') || key === 'sort_by') {
          searchParams.delete(key);
        }
      });

      // Add sort_by
      const sortBy = document.querySelector('input[name="sort_by"]:checked');
      if (sortBy) {
        searchParams.set('sort_by', sortBy.value);
      }

      // Add all active checkbox filters (metafields + product_type + others)
      const checkedFilters = document.querySelectorAll('.filter-options input[type="checkbox"]:checked');
      checkedFilters.forEach((input) => {
        searchParams.append(input.name, input.value);
      });

      // Redirect with new filters
      window.location.href = url.toString();
    });

    // Clear all filters
    clearBtn.addEventListener('click', function () {
      window.location.href = window.location.pathname;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function () {
    // Supprime tous les nœuds DOM suivant `node` jusqu'à `root` (inclus dans la remontée)
    function removeFollowingNodes(node, root) {
      let current = node;
      while (current !== root) {
        let sibling = current.nextSibling;
        while (sibling) {
          const next = sibling.nextSibling;
          current.parentNode.removeChild(sibling);
          sibling = next;
        }
        current = current.parentNode;
      }
    }

    // Coupe le contenu DOM à `cutAt` caractères en préservant le HTML (liens, gras…)
    function applyDomCut(container, cutAt, suffix) {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      let charCount = 0;
      let node;
      while ((node = walker.nextNode())) {
        const len = node.textContent.length;
        if (charCount + len >= cutAt) {
          node.textContent = node.textContent.slice(0, cutAt - charCount).trimEnd() + (suffix || '');
          removeFollowingNodes(node, container);
          return;
        }
        charCount += len;
      }
    }

    // Trouve le décalage de caractère où la ligne maxLines+1 commence (Range API — précis, marges incluses)
    function findLineCutPoint(content, maxLines) {
      const clone = content.cloneNode(true);
      clone.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;' +
        'top:0;left:-9999px;width:' + content.offsetWidth + 'px;';
      document.body.appendChild(clone);

      const range = document.createRange();
      const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);

      let lineCount = 1;
      let lastTop = null;
      let globalOffset = 0;
      let cutAt = null;
      let node;

      outer:
      while ((node = walker.nextNode())) {
        const text = node.textContent;
        for (let i = 0; i < text.length; i++) {
          range.setStart(node, i);
          range.setEnd(node, i + 1);
          const rect = range.getBoundingClientRect();

          if (rect.height > 0) {
            const top = Math.round(rect.top);
            if (lastTop === null) {
              lastTop = top;
            } else if (top > lastTop + 2) {
              lineCount++;
              lastTop = top;
              if (lineCount > maxLines) {
                cutAt = globalOffset + i;
                break outer;
              }
            }
          }
        }
        globalOffset += text.length;
      }

      document.body.removeChild(clone);
      return cutAt; // null = tout le texte tient dans maxLines
    }

    function smartClamp(wrapper) {
      const content = wrapper.querySelector('.text-block__content');
      const toggle = wrapper.querySelector('.text-block__toggle');
      if (!content || !toggle) return;

      const isOpen = wrapper.classList.contains('is-open');

      if (content.dataset.originalHtml == null) {
        content.dataset.originalHtml = content.innerHTML;
      }

      if (isOpen) {
        content.innerHTML = content.dataset.originalHtml;
        content.classList.remove('js-clamped');
        toggle.hidden = false;
        return;
      }

      // Restaurer le HTML complet sans aucun clamp
      content.classList.remove('js-clamped');
      content.innerHTML = content.dataset.originalHtml;

      const maxLines = parseInt(getComputedStyle(content).getPropertyValue('--readmore-lines')) || 3;
      const cutAt = findLineCutPoint(content, maxLines);

      if (cutAt === null) {
        toggle.hidden = true;
        return;
      }

      const fullText = content.textContent;

      // Remonter au dernier espace pour ne pas couper en plein milieu d'un mot
      const slice = fullText.slice(0, cutAt);
      const lastSpace = slice.lastIndexOf(' ');
      const wordCutAt = lastSpace > cutAt * 0.5 ? lastSpace : cutAt;

      // S'il ne reste rien de significatif après la coupure, masquer le bouton
      if (fullText.slice(wordCutAt).trim().length === 0) {
        toggle.hidden = true;
        return;
      }

      applyDomCut(content, wordCutAt, '...');
      content.classList.add('js-clamped');
      toggle.hidden = false;
    }

    function updateAll() {
      document.querySelectorAll('[data-readmore="true"]').forEach(smartClamp);
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.text-block__toggle');
      if (!btn) return;
      const wrapper = btn.closest('[data-readmore]');
      if (!wrapper) return;

      wrapper.classList.toggle('is-open');
      const content = wrapper.querySelector('.text-block__content');

      if (wrapper.classList.contains('is-open')) {
        if (content) {
          content.innerHTML = content.dataset.originalHtml || content.innerHTML;
          content.classList.remove('js-clamped');
        }
        btn.textContent = btn.dataset.labelClose || 'LIRE MOINS';
      } else {
        smartClamp(wrapper);
        btn.textContent = btn.dataset.label || 'LIRE PLUS';
      }
    });

    window.addEventListener('resize', updateAll);

    if (document.readyState !== 'loading') {
      updateAll();
    } else {
      document.addEventListener('DOMContentLoaded', updateAll);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
